import { render } from "./B2bPageConsultCmrByLink.vue?vue&type=template&id=bb1ad692&scoped=true&lang=pug"
import script from "./B2bPageConsultCmrByLink.vue?vue&type=script&lang=js"
export * from "./B2bPageConsultCmrByLink.vue?vue&type=script&lang=js"

import "./B2bPageConsultCmrByLink.vue?vue&type=style&index=0&id=bb1ad692&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb1ad692"]])

export default __exports__